import mainLogoLight from '../assets/img/world-vision-logo.png';
import burgerIcon from '../assets/img/burger-icon.svg';
import mainLogoDark from '../assets/img/world-vision-logo-dark.png';
import iconPhone from '../assets/img/icons/ico-phone.svg';
import iconMail from '../assets/img/icons/ico-mail.svg';
import iconCheck from '../assets/img/icons/ico-check.png';
import iconComment from '../assets/img/icons/ico-comment.svg';
import donateBanner from '../assets/img/donate-banner.png';
import sslCheckout from '../../src/assets/img/v2/ssl-checkout.webp';
import successIcon from '../assets/img/success.gif';
import rollin from '../assets/img/rollin.gif'

import defaultMobileBackground from '../assets/img/page-bg-mobile.jpg'

const images = {
    burgerIcon,
    defaultMobileBackground,
    mainLogoLight,
    mainLogoDark,
    iconPhone,
    iconMail,
    iconCheck,
    iconComment,
    donateBanner,
    sslCheckout,
    successIcon,
    rollin
}

export default images